import Autocomplete from '@mui/joy/Autocomplete';
import AutocompleteOption from '@mui/joy/AutocompleteOption';
import FormControl, { FormControlProps } from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import { FC, JSX, useMemo } from 'react';
import { COUNTRIES, sortAlphanumeric } from '@consolidocs-ui/utils';
import { useTranslation } from 'react-i18next';

type Country =
  | {
      code: string;
      label: string;
      phone: string;
      suggested?: undefined;
    }
  | {
      code: string;
      label: string;
      phone: string;
      suggested: boolean;
    }
  | null;

interface CountrySelectorProps extends Omit<FormControlProps, 'onChange'> {
  value?: Country | null;
  onChange: (newValue: Country) => void;
}

export const CountrySelector: FC<CountrySelectorProps> = ({
  sx,
  value = { code: 'IN', label: 'India', phone: '91' },
  onChange,
  ...other
}): JSX.Element => {
  const { t } = useTranslation();
  /* by name: COUNTRIES itself is in ISO-code order */
  const countryOptions = useMemo(
    () => sortAlphanumeric(COUNTRIES, ({ label }) => label),
    []
  );
  return (
    <FormControl
      {...other}
      sx={[{ display: { sm: 'contents' } }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      <FormLabel>{t('Country')}</FormLabel>
      <Autocomplete
        size="sm"
        autoHighlight
        value={value || null || undefined}
        onChange={(e, newValue) => {
          if (newValue) {
            onChange(newValue);
          }
        }}
        isOptionEqualToValue={(option, val) => option.code === val?.code}
        options={countryOptions}
        getOptionLabel={(option) => option.label || ''}
        renderOption={(optionProps, option) => (
          <AutocompleteOption {...optionProps} key={option.code}>
            <img
              loading="lazy"
              width="20"
              height="15"
              style={{ marginRight: 8 }}
              src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
              alt=""
            />
            {option.label} (+{option.phone})
          </AutocompleteOption>
        )}
        slotProps={{
          listbox: {
            sx: {
              maxHeight: 300,
              zIndex: 10000,
              position: 'absolute',
            },
          },
          input: {
            autoComplete: 'new-password',
          },
        }}
      />
    </FormControl>
  );
};
